const getTableHeadings = (classes) => ([
  {
    id: 'programName',
    header: 'PROGRAM NAME',
    isLink: true
  },
  {
    id: 'accountName',
    header: 'ACCOUNT NAME',
  },
  {
    id: 'numberOfUsers',
    header: 'NUMBER OF USERS',
    isNumber: true,
    className: `${classes.headingRight}`
  },
  {
    id: 'systemsEnrolled',
    header: 'SYSTEMS ENROLLED',
    className: `${classes.headingRight}`
  },
  {
    id: 'totalEnergy',
    header: 'TOTAL ENERGY (kWh)',
    className: `${classes.headingRight}`
  },
  {
    id: 'totalPower',
    header: 'TOTAL POWER (kW)',
    className: `${classes.headingRight}`
  },
  {
    id: 'status',
    header: 'STATUS',
  },
])

export {
  getTableHeadings
}